// ts-gql-integrity:21ea43a2c2bb6392fa99b5d8ceb8bf37
/*
ts-gql-meta-begin
{
  "hash": "a3974c72e080f62e8b9a5195a790d8b6"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type NationalHomepageQueryVariables = SchemaTypes.Exact<{
  country: SchemaTypes.Scalars['String'];
}>;


type NationalHomepageQuery = (
  { readonly __typename: 'Query' }
  & { readonly cfNationalHomepageCollection: SchemaTypes.Maybe<(
    { readonly __typename: 'CFNationalHomepageCollection' }
    & { readonly items: ReadonlyArray<SchemaTypes.Maybe<(
      { readonly __typename: 'CFNationalHomepage' }
      & Pick<SchemaTypes.CFNationalHomepage, 'navigationMenu'>
    )>> }
  )> }
);


export type type = TypedDocumentNode<{
  type: "query";
  result: NationalHomepageQuery;
  variables: NationalHomepageQueryVariables;
  documents: SchemaTypes.TSGQLDocuments;
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    NationalHomepage: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"NationalHomepage\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"country\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}},\"directives\":[]}],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"cfNationalHomepageCollection\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"limit\"},\"value\":{\"kind\":\"IntValue\",\"value\":\"1\"}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"where\"},\"value\":{\"kind\":\"ObjectValue\",\"fields\":[{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"country_contains_all\"},\"value\":{\"kind\":\"ListValue\",\"values\":[{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"country\"}}]}}]}}],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"items\"},\"arguments\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"navigationMenu\"},\"arguments\":[],\"directives\":[]}]}}]}}]}}]}")
